export const validateName = (name?: string) => {
  if (!name) return false;


  const regex = /[a-zA-Zа-яА-ЯёЁґҐєЄіІїЇоОуУфФцЦчЧшШщЩ]/;

  return regex.test(name);
};
